import ErrorView, { Props } from 'widget/Errors/ErrorView/ErrorView';
import hydrate from 'widget/hydrate';

hydrate<Props>(ErrorView);
